import * as Country from '@/services/country';
import * as Language from '@/services/language';

export default {
  GET_COUNTRIES({ commit }) {
    return Country.getCountries()
      .then(response => {
        commit('SET_COUNTRIES', response.data.data);
        return response;
      })
      .catch(err => {
        return err;
      });
  },

  GET_TRANSLATION({ commit, state }, payload) {
    return Language.getTranslation(payload)
      .then(response => {
        return response;
      })
      .catch(err => {
        return err;
      });
  }
};
